import { useEffect } from 'react';

const lockScroll = () => {
  const scrollY = window.scrollY.toString();
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.overflowY = 'scroll';
  document.body.style.width = '100%';
  document.body.dataset.scrollY = scrollY;
};

const unlockScroll = () => {
  const scrollY = document.body.dataset.scrollY;
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.overflowY = '';
  document.body.style.width = '';
  delete document.body.dataset.scrollY;

  if (scrollY) {
    window.scrollTo(0, parseInt(scrollY, 10));
  }
};

const useToggleBodyScroll = (modalOpen) => {
  useEffect(() => {
    if (modalOpen) {
      lockScroll();
    } else {
      unlockScroll();
    }

    return () => {
      unlockScroll();
    };
  }, [modalOpen]);
};

export default useToggleBodyScroll;